// extracted by mini-css-extract-plugin
module.exports = {"desktop":"desktopCards_desktop__egysH","isVisible":"desktopCards_isVisible__2r3Fx","hide":"desktopCards_hide__zfn5Y"};